module.exports = __webpack_public_path__ + "img/05808a2.svg";